<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原样不动） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-spinner="el-icon-loading"
        element-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-select
            v-model.number="searchParams.type"
            placeholder="请选择类型"
            style="width: 180px"
            @change="handleTypeChange"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <el-select
            v-model.number="searchParams.box_id"
            placeholder="请选择宝箱"
            style="width: 220px; margin-left: 10px"
          >
            <el-option
              v-for="item in boxList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getList"
            style="margin-left: 10px"
            >搜索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            @click="resetSearch"
            style="margin-left: 10px"
            >重置</el-button
          >

          <el-button
            type="success"
            icon="el-icon-plus"
            @click="handleAddTreasure"
            style="margin-left: 10px"
            >添加宝箱</el-button
          >

          <el-popover
            placement="bottom"
            title="显示列筛选"
            trigger="click"
            width="220"
          >
            <el-checkbox-group v-model="checkedColumns">
              <el-checkbox
                v-for="item in columnOptions"
                :key="item.prop"
                :label="item.prop"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 8px">
              <el-button size="mini" @click="handleCheckAll">全选</el-button>
              <el-button size="mini" @click="handleClearAll">清空</el-button>
            </div>
            <el-button
              slot="reference"
              icon="el-icon-s-tools"
              type="info"
              style="margin-left: 10px"
              >列筛选</el-button
            >
          </el-popover>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="宝箱名称"
            prop="box_name"
            min-width="160"
            v-if="checkedColumns.includes('box_name')"
          />
          <el-table-column
            label="商品名称"
            prop="goods_name"
            min-width="180"
            v-if="checkedColumns.includes('goods_name')"
          />
          <el-table-column
            label="商品名称"
            width="180"
            align="center"
            v-if="checkedColumns.includes('goods_name')"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.goods_name }}--{{ scope.row.goods_id }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="商品图片"
            width="120"
            align="center"
            v-if="checkedColumns.includes('goods_image')"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.goods_image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('price')"
          />
          <el-table-column
            label="兑换价"
            prop="recovery_price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('recovery_price')"
          />
          <el-table-column
            label="等级ID"
            prop="level_id"
            width="90"
            align="center"
            v-if="checkedColumns.includes('level_id')"
          />
          <el-table-column
            label="当前数量"
            prop="num"
            width="90"
            align="center"
            v-if="checkedColumns.includes('num')"
          />
          <el-table-column
            label="原始数量"
            prop="origin_num"
            width="100"
            align="center"
            v-if="checkedColumns.includes('origin_num')"
          />
          <el-table-column
            label="概率"
            width="110"
            align="center"
            v-if="checkedColumns.includes('probability')"
          >
            <template slot-scope="scope">
              {{ parseFloat(scope.row.probability).toFixed(5) }}%
            </template>
          </el-table-column>
          <el-table-column
            label="商品类型"
            width="110"
            align="center"
            v-if="checkedColumns.includes('goods_type')"
          >
            <template slot-scope="scope">{{
              scope.row.goods_type == 1 ? "真实" : "虚拟"
            }}</template>
          </el-table-column>
          <!-- <el-table-column
            label="完成状态"
            width="100"
            align="center"
            v-if="checkedColumns.includes('is_finish')"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.is_finish == 1 ? 'text-success' : 'text-danger'
                "
              >
                {{ scope.row.is_finish == 1 ? "已完成" : "进行中" }}
              </span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            v-if="checkedColumns.includes('created_at')"
          />

          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="openTreasurePrize(scope.row)"
                >赏品</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        />

        <!-- 所有弹窗原样保留，不改动 -->
        <el-dialog
          title="添加宝箱"
          :visible.sync="addDialogVisible"
          width="600px"
          append-to-body
          @close="resetAddForm"
        >
          <el-form
            :model="addForm"
            :rules="addRules"
            ref="addFormRef"
            label-width="100px"
          >
            <el-form-item label="赏品信息" prop="goods_id">
              <div style="display: flex; align-items: center">
                <div v-if="addForm.image" style="margin-right: 15px">
                  <img
                    :src="addForm.image"
                    style="width: 60px; height: 60px; object-fit: cover"
                  />
                </div>
                <el-button type="primary" @click="openGoodsLibrary">
                  选择赏品
                </el-button>
                <span style="margin-left: 15px">
                  已选ID：{{ addForm.goods_id || "未选择" }}
                </span>
              </div>
            </el-form-item>

            <el-form-item label="等级ID">
              <span style="font-size: 14px; color: #333"
                >9（固定不可修改）</span
              >
            </el-form-item>

            <el-form-item label="价格" prop="price">
              <el-input v-model.number="addForm.price" style="width: 300px" />
            </el-form-item>
            <el-form-item label="兑换价格" prop="recovery_price">
              <el-input
                v-model.number="addForm.recovery_price"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="addDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitAddTreasure"
              >确认添加</el-button
            >
          </div>
        </el-dialog>

        <!-- ========== 选择赏品弹窗（核心修改：类型、等级联动下拉） ========== -->
        <el-dialog
          title="选择赏品"
          :visible.sync="libraryVisible"
          width="1100px"
          append-to-body
        >
          <el-form
            :inline="true"
            :model="libSearch"
            style="margin-bottom: 10px"
          >
            <el-form-item label="商品名称">
              <el-input
                v-model="libSearch.title"
                placeholder="搜索名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select
                v-model.number="libSearch.type"
                placeholder="请选择类型"
                style="width: 150px"
                clearable
                @change="handleLibTypeChange"
              >
                <el-option
                  v-for="t in allGoodsTypeList"
                  :key="t.type"
                  :label="t.desc"
                  :value="t.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="等级">
              <el-select
                v-model.number="libSearch.level_id"
                placeholder="全部"
                clearable
                style="width: 150px"
              >
                <el-option
                  v-for="item in currentLibLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="getGoodsLibrary">搜索</el-button>
            <el-button @click="resetLibSearch">重置</el-button>
          </el-form>

          <el-table
            :data="prizeLibrary"
            border
            size="small"
            v-loading="libLoading"
            style="width: 100%"
          >
            <el-table-column label="ID" prop="id" width="80" align="center" />
            <el-table-column label="商品图片" width="100" align="center">
              <template slot-scope="scope">
                <img
                  :src="scope.row.image"
                  style="width: 50px; height: 50px; object-fit: cover"
                />
              </template>
            </el-table-column>
            <el-table-column label="商品名称" prop="title" min-width="200" />
            <el-table-column
              label="等级"
              prop="level_name"
              width="100"
              align="center"
            />
            <el-table-column
              label="价格"
              prop="price"
              width="100"
              align="center"
            />
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="selectGoods(scope.row)">
                  选择此赏品
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="libSizeChange"
            @current-change="libPageChange"
            :current-page="libPage"
            :page-size="libSize"
            layout="total,prev,pager,next"
            :total="libTotal"
            style="margin-top: 15px; text-align: right"
          />

          <div style="text-align: right; margin-top: 15px">
            <el-button @click="libraryVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="宝箱包含赏品"
          :visible.sync="treasureVisible"
          width="1200px"
          append-to-body
        >
          <div style="margin-bottom: 15px; display: flex; gap: 10px">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openBoxAddPrizeDialog"
            >
              添加赏品
            </el-button>
          </div>

          <div style="margin-bottom: 25px">
            <p style="font-weight: bold; margin-bottom: 8px">
              待提交赏品（可编辑）
            </p>
            <div v-loading="prizeLoading" element-loading-text="加载中...">
              <el-table
                :data="tempPrizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  label="赏品ID"
                  prop="goods_id"
                  width="100"
                  align="center"
                />
                <el-table-column label="赏品图片" width="120" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="赏品名称"
                  prop="goods_name"
                  min-width="200"
                />
                <el-table-column label="商品类型" width="100" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.goods_type == 1 ? "真实" : "虚拟" }}
                  </template>
                </el-table-column>
                <el-table-column label="等级名称" width="120" align="center">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.level_id"
                      size="mini"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in levelDataList"
                        :key="item.level_id"
                        :label="item.name"
                        :value="item.level_id"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="概率(%)" width="120" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.probability"
                      size="mini"
                      style="width: 100px"
                      @input="
                        scope.row.probability = scope.row.probability.replace(
                          /[^\d.]/g,
                          ''
                        )
                      "
                      @blur="formatFiveDecimal(scope.row, 'probability')"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="价格" width="120" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.price"
                      size="mini"
                      style="width: 100px"
                      @input="
                        scope.row.price = scope.row.price.replace(/[^\d.]/g, '')
                      "
                      @blur="formatFiveDecimal(scope.row, 'price')"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="兑换价" width="120" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.recovery_price"
                      size="mini"
                      style="width: 100px"
                      @input="
                        scope.row.recovery_price =
                          scope.row.recovery_price.replace(/[^\d.]/g, '')
                      "
                      @blur="formatFiveDecimal(scope.row, 'recovery_price')"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      size="mini"
                      @click="delTempPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div>
            <p style="font-weight: bold; margin-bottom: 8px">
              已有赏品列表（数据库）
            </p>
            <div v-loading="prizeLoading" element-loading-text="加载中...">
              <el-table
                :data="treasureList"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  label="ID"
                  prop="id"
                  width="80"
                  align="center"
                />
                <el-table-column label="赏品图片" width="120" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="赏品名称"
                  prop="goods_name"
                  min-width="200"
                />
                <el-table-column label="等级名称" width="120" align="center">
                  <template slot-scope="scope">
                    {{ getLevelName(scope.row.level_id) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="价格"
                  prop="price"
                  width="120"
                  align="center"
                />
                <el-table-column
                  label="回收价"
                  prop="recovery_price"
                  width="120"
                  align="center"
                />
                <el-table-column
                  label="概率(%)"
                  prop="probability"
                  width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ Number(scope.row.probability).toFixed(5) }}
                  </template>
                </el-table-column>
                <el-table-column label="商品类型" width="100" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.goods_type == 1 ? "真实" : "虚拟" }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="100"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #f56c6c"
                      @click.stop="handleDeletePrize(scope.row.id)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="
                  margin-top: 12px;
                  display: flex;
                  gap: 20px;
                  padding: 8px 12px;
                  background: #f7f8fa;
                  border-radius: 6px;
                "
              >
                <div>
                  <span style="color: #333; font-weight: 500">概率总和：</span>
                  <span
                    style="color: #1989fa; font-size: 14px; font-weight: bold"
                  >
                    {{ sum_numsum_proObj.sum_pro }}%
                  </span>
                </div>
              </div>
              <el-pagination
                @size-change="prizeSizeChange"
                @current-change="prizeCurrentChange"
                :current-page="prizePage"
                :page-size="prizeSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="prizeTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>
          </div>

          <div slot="footer" style="text-align: right; margin-top: 15px">
            <el-button @click="treasureVisible = false">关闭</el-button>
            <el-button
              type="primary"
              @click="submitAllTempPrize"
              :loading="submitLoading"
              >确认提交选中赏品</el-button
            >
          </div>

          <!-- ========== 添加宝箱赏品弹窗（类型等级联动） ========== -->
          <el-dialog
            title="选择宝箱赏品"
            :visible.sync="boxAddPrizeDialogVisible"
            width="1100px"
            append-to-body
            @close="resetBoxGoodsSearch"
          >
            <div
              style="
                margin-bottom: 15px;
                display: flex;
                gap: 10px;
                align-items: center;
              "
            >
              <el-input
                v-model="boxGoodsSearch.title"
                placeholder="商品名称"
                clearable
                style="width: 220px"
              ></el-input>

              <el-select
                v-model="boxGoodsSearch.type"
                placeholder="类型"
                clearable
                style="width: 180px"
                @change="handleBoxTypeChange"
              >
                <el-option
                  v-for="t in allGoodsTypeList"
                  :key="t.type"
                  :label="t.desc"
                  :value="t.type"
                />
              </el-select>

              <el-select
                v-model.number="boxGoodsSearch.level_id"
                placeholder="等级"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in currentBoxLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>

              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getBoxGoodsList"
              >
                搜索
              </el-button>
              <el-button icon="el-icon-refresh" @click="resetBoxGoodsSearch">
                重置
              </el-button>
            </div>

            <div v-loading="boxGoodsLoading" element-loading-text="加载中...">
              <el-table
                :data="boxGoodsList"
                border
                stripe
                size="small"
                style="width: 100%"
                @row-click="handleBoxSelectGoods"
                highlight-current-row
              >
                <el-table-column label="选择" width="60" align="center">
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row._checked"
                      :disabled="scope.row._disabled"
                      @change="handleBoxSelectGoods(scope.row)"
                    ></el-checkbox>
                  </template>
                </el-table-column>

                <el-table-column
                  label="ID"
                  prop="id"
                  width="80"
                  align="center"
                />
                <el-table-column label="图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="名称" prop="title" min-width="220" />
                <el-table-column label="类型" width="140" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品"
                        : "未知"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="价格"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                />
              </el-table>

              <el-pagination
                @size-change="handleBoxGoodsSizeChange"
                @current-change="handleBoxGoodsCurrentChange"
                :current-page="boxGoodsSearch.page"
                :page-size="boxGoodsSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="boxGoodsTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>

            <div slot="footer">
              <el-button @click="boxAddPrizeDialogVisible = false"
                >取消</el-button
              >
              <el-button type="primary" @click="addSelectedToTemp"
                >确认添加到暂存区</el-button
              >
            </div>
          </el-dialog>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（纯列表，弹窗不动） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索栏 -->
        <div class="mobile-search-group">
          <el-select
            v-model.number="searchParams.type"
            placeholder="选择类型"
            clearable
            size="medium"
            style="width: 100%"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <el-select
            v-model.number="searchParams.box_id"
            placeholder="选择宝箱"
            clearable
            size="medium"
            style="width: 100%; margin-top: 8px"
          >
            <el-option
              v-for="item in boxList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <img :src="item.goods_image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.goods_name }}</div>
                <div class="meta">
                  宝箱：{{ item.box_name }} | ID：{{ item.id }}
                </div>
              </div>
            </div>

            <div class="card-body">
              <div>价格：¥{{ item.price }}</div>
              <div>兑换价：¥{{ item.recovery_price }}</div>
              <div>等级：{{ item.level_id }}</div>
              <div>数量：{{ item.num }} / {{ item.origin_num }}</div>
              <div>概率：{{ parseFloat(item.probability).toFixed(5) }}%</div>
              <div style="font-size: 12px; color: #999; margin-top: 4px">
                创建时间：{{ item.created_at }}
              </div>
            </div>
          </div>
        </div>

        <!-- 移动端分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "TreasureBoxList",
  data() {
    return {
      loading: false,
      tableData: [],
      pageTotal: 0,
      typeOptions: [],
      boxList: [],
      searchParams: { page: 1, page_size: 10, type: 2, box_id: "" },
      levelDataList: [],

      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "宝箱名称", prop: "box_name" },
        { label: "商品名称", prop: "goods_name" },
        { label: "商品图片", prop: "goods_image" },
        { label: "价格", prop: "price" },
        { label: "兑换价", prop: "recovery_price" },
        { label: "等级ID", prop: "level_id" },
        { label: "当前数量", prop: "num" },
        { label: "原始数量", prop: "origin_num" },
        { label: "概率", prop: "probability" },
        { label: "商品类型", prop: "goods_type" },
        { label: "完成状态", prop: "is_finish" },
        { label: "创建时间", prop: "created_at" },
      ],
      checkedColumns: [
        "id",
        "box_name",
        "goods_name",
        "goods_image",
        "price",
        "recovery_price",
        "level_id",
        "num",
        "origin_num",
        "probability",
        "goods_type",
        "is_finish",
        "created_at",
      ],

      addDialogVisible: false,
      addForm: {
        goods_id: "",
        image: "",
        level_id: 9,
        price: "",
        recovery_price: "",
      },
      addRules: {
        goods_id: [{ required: true, message: "请选择赏品", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        recovery_price: [
          { required: true, message: "请输入兑换价格", trigger: "blur" },
        ],
      },

      libraryVisible: false,
      libLoading: false,
      prizeLibrary: [],
      // 全量类型数据源（从接口goods_level提取）
      allGoodsTypeList: [],
      // 当前弹窗选中类型对应的等级列表
      currentLibLevelOptions: [],
      libSearch: { title: "", type: "", level_id: "" },
      libPage: 1,
      libSize: 10,
      libTotal: 0,

      treasureVisible: false,
      prizeLoading: false,
      treasureList: [],
      tempPrizeList: [],
      prizePage: 1,
      prizeSize: 10,
      prizeTotal: 0,
      currentBox: null,
      submitLoading: false,

      boxAddPrizeDialogVisible: false,
      boxGoodsLoading: false,
      boxGoodsList: [],
      boxGoodsTotal: 0,
      boxGoodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: "",
      },
      // 添加赏品弹窗当前等级选项
      currentBoxLevelOptions: [],
      flagType: "",

      sum_numsum_proObj: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await api.treasureList.index({ params: this.searchParams });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageTotal = res.data.data.total || 0;
          this.typeOptions = res.data.data.box_list || [];
          this.levelDataList = res.data.data.level_data || [];
          const curr = this.typeOptions.find(
            (t) => t.type == this.searchParams.type
          );
          this.boxList = curr ? curr.box_list : [];
        }
      } finally {
        this.loading = false;
      }
    },

    handleTypeChange() {
      const curr = this.typeOptions.find(
        (t) => t.type == this.searchParams.type
      );
      this.boxList = curr ? curr.box_list : [];
      this.searchParams.box_id = "";
    },

    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, type: 2, box_id: "" };
      this.getList();
    },

    handleSizeChange(v) {
      this.searchParams.page_size = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.searchParams.page = v;
      this.getList();
    },

    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    handleAddTreasure() {
      this.addDialogVisible = true;
      this.resetAddForm();
    },
    resetAddForm() {
      this.addForm = {
        goods_id: "",
        image: "",
        level_id: 9,
        price: "",
        recovery_price: "",
      };
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate();
        }
      });
    },
    async submitAddTreasure() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          await api.treasureList.add(this.addForm);
          this.addDialogVisible = false;
          this.getList();
        } catch (err) {
        } finally {
          this.loading = false;
        }
      });
    },

    openGoodsLibrary() {
      this.libSearch = { title: "", type: "", level_id: "" };
      this.libPage = 1;
      this.currentLibLevelOptions = [];
      this.getGoodsLibrary();
    },
    // 赏品弹窗切换类型，联动等级
    handleLibTypeChange() {
      this.libSearch.level_id = "";
      const targetType = this.allGoodsTypeList.find(t => t.type === this.libSearch.type);
      this.currentLibLevelOptions = targetType ? targetType.goods_level : [];
    },
    async getGoodsLibrary() {
      this.libLoading = true;
      try {
        const res = await api.goods.index({
          params: {
            page: this.libPage,
            page_size: this.libSize,
            type: this.libSearch.type,
            level_id: this.libSearch.level_id,
            title: this.libSearch.title,
            flag: this.flagType,
          },
        });
        if (res.data.code == 1000) {
          this.prizeLibrary = res.data.data.data || [];
          this.libTotal = res.data.data.total || 0;
          // 保存全量type列表
          this.allGoodsTypeList = res.data.data.goods_level || [];
          // 联动当前选中type的等级
          this.handleLibTypeChange();
          this.libraryVisible = true;
        }
      } finally {
        this.libLoading = false;
      }
    },
    selectGoods(row) {
      this.addForm.goods_id = row.id;
      this.addForm.image = row.image;
      this.libraryVisible = false;
    },
    resetLibSearch() {
      this.libSearch = { title: "", type: "", level_id: "" };
      this.currentLibLevelOptions = [];
      this.getGoodsLibrary();
    },
    libSizeChange(v) {
      this.libSize = v;
      this.getGoodsLibrary();
    },
    libPageChange(v) {
      this.libPage = v;
      this.getGoodsLibrary();
    },
    prizeSizeChange(v) {
      this.prizeSize = v;
      this.getTreasurePrizeList();
    },
    prizeCurrentChange(v) {
      this.prizePage = v;
      this.getTreasurePrizeList();
    },
    openTreasurePrize(row) {
      this.flagType = row.type;
      if (this.currentBox && this.currentBox.id !== row.id) {
        this.tempPrizeList = [];
      }
      this.currentBox = row;
      this.prizePage = 1;
      this.getTreasurePrizeList();
    },
    async getTreasurePrizeList() {
      this.prizeLoading = true;
      try {
        const res = await api.treasureList.treasurePrizeList({
          params: {
            page: this.prizePage,
            page_size: this.prizeSize,
            type: this.searchParams.type,
            box_goods_id: this.currentBox.goods_id,
          },
        });
        if (res.data.code == 1000) {
          this.treasureList = res.data.data.data || [];
          this.prizeTotal = res.data.data.total || 0;
          this.sum_numsum_proObj = res.data.data;
          this.treasureVisible = true;
        }
      } finally {
        this.prizeLoading = false;
      }
    },

    openBoxAddPrizeDialog() {
      this.boxAddPrizeDialogVisible = true;
      this.resetBoxGoodsSearch();
    },
    // 添加赏品弹窗切换类型联动等级
    handleBoxTypeChange() {
      this.boxGoodsSearch.level_id = "";
      const targetType = this.allGoodsTypeList.find(t => t.type === this.boxGoodsSearch.type);
      this.currentBoxLevelOptions = targetType ? targetType.goods_level : [];
    },
    async getBoxGoodsList() {
      this.boxGoodsLoading = true;
      try {
        const res = await api.goods.index({
          params: this.boxGoodsSearch,
        });
        if (res.data.code == 1000) {
          this.boxGoodsList = res.data.data.data || [];
          this.boxGoodsTotal = res.data.data.total || 0;
          // 同步全量type数据
          this.allGoodsTypeList = res.data.data.goods_level || [];
          this.handleBoxTypeChange();

          this.boxGoodsList.forEach((item) => {
            const existTemp = this.tempPrizeList.some(
              (i) => i.goods_id == item.id
            );
            const existDb = this.treasureList.some(
              (i) => i.goods_id == item.id
            );

            let isDisabled = false;
            if (item.goods_type == 1) {
              isDisabled = existTemp || existDb;
            } else {
              isDisabled = false;
            }

            this.$set(item, "_checked", existTemp);
            this.$set(item, "_disabled", isDisabled);
          });
        }
      } finally {
        this.boxGoodsLoading = false;
      }
    },
    handleBoxSelectGoods(row) {
      if (row._disabled) return;
      row._checked = !row._checked;
      this.$set(row, "_checked", row._checked);
    },

    addSelectedToTemp() {
      const selected = this.boxGoodsList.filter((i) => i._checked);
      if (!selected.length) {
        return this.$message.warning("请选择赏品");
      }

      selected.forEach((item) => {
        if (item.goods_type == 1) {
          const has = this.tempPrizeList.some((i) => i.goods_id == item.id);
          if (has) return;
        }

        this.tempPrizeList.push({
          goods_id: item.id,
          goods_name: item.title,
          goods_image: item.image,
          goods_type: item.goods_type,
          level_id: item.level_id || "",
          price: parseFloat(item.price || 0).toFixed(5),
          recovery_price: parseFloat(item.price || 0).toFixed(5),
          probability: "0.00000",
          origin_num: 0,
        });
      });

      this.boxAddPrizeDialogVisible = false;
      this.$message.success("已添加到暂存区");
    },
    delTempPrize(row) {
      this.tempPrizeList = this.tempPrizeList.filter(
        (i) => i.goods_id != row.goods_id
      );
      this.$message.success("删除成功");
      this.getTreasurePrizeList();
    },

    formatFiveDecimal(row, field) {
      let val = parseFloat(row[field] || 0);
      row[field] = val.toFixed(5);
    },

    getLevelName(levelId) {
      const item = this.levelDataList.find((i) => i.level_id == levelId);
      return item ? item.name : "-";
    },

    async handleDeletePrize(prize_id) {
      const confirm = await this.$confirm("确定删除该赏品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch(() => false);
      if (!confirm) return;

      this.prizeLoading = true;
      try {
        const res = await api.treasureList.del({
          prize_id: prize_id.toString(),
        });
        if (res.data.code == 1000) {
          this.getTreasurePrizeList();
        }
      } catch (e) {
      } finally {
        this.prizeLoading = false;
      }
    },

    async submitAllTempPrize() {
      if (!this.tempPrizeList.length) {
        return this.$message.warning("暂存区为空");
      }

      const emptyLevel = this.tempPrizeList.find((i) => !i.level_id);
      if (emptyLevel) {
        this.$message.warning("请选择所有赏品的等级");
        return;
      }

      let existProb = this.treasureList.reduce(
        (sum, item) => sum + parseFloat(item.probability),
        0
      );
      let tempProb = this.tempPrizeList.reduce(
        (sum, item) => sum + parseFloat(item.probability),
        0
      );
      let total = existProb + tempProb;

      if (total > 100) {
        this.$message.warning(
          `概率总和不能超过100%，当前：${total.toFixed(5)}%`
        );
        return;
      }

      this.submitLoading = true;
      try {
        const box_prize_info = this.tempPrizeList.map((i) => ({
          goods_id: i.goods_id,
          probability: i.probability,
          level_id: i.level_id,
          price: i.price,
          recovery_price: i.recovery_price,
          goods_type: i.goods_type,
        }));

        const params = {
          box_id: this.currentBox.box_id,
          box_goods_id: this.currentBox.goods_id,
          type: this.searchParams.type,
          box_prize_info: JSON.stringify(box_prize_info),
        };
        const res = await api.treasureList.addTreasurePrize(params);
        if (res.data.code == 1000) {
          this.tempPrizeList = [];
          this.getTreasurePrizeList();
        }
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },

    resetBoxGoodsSearch() {
      this.boxGoodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: this.flagType,
      };
      this.currentBoxLevelOptions = [];
      this.getBoxGoodsList();
    },
    handleBoxGoodsSizeChange(v) {
      this.boxGoodsSearch.page_size = v;
      this.getBoxGoodsList();
    },
    handleBoxGoodsCurrentChange(v) {
      this.boxGoodsSearch.page = v;
      this.getBoxGoodsList();
    },
  },
};
</script>

<style scoped>
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.text-success {
  color: #67c23a;
}
.text-danger {
  color: #f56c6c;
}

/* ====================== 移动端样式 ====================== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.finish {
  color: #00c48c;
}
.doing {
  color: #f56c6c;
}
.card-footer {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/box/treasurePrize.vue